// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__JPj1L","mainHeader":"Header_mainHeader__N9Njs","imgContainer":"Header_imgContainer__RYDdJ"};